import { string } from 'prop-types';

const Icon = ({ icon }) => <i className="material-icons">{icon}</i>;

Icon.propTypes = { icon: string.isRequired };

export default Icon;
